import React from "react";
import styled from "styled-components";
import { mobile, tablet, desktop } from "./Media";
import { PortalTableToolbar } from "./BusinessPortalComponents";

const Header = styled(PortalTableToolbar)`
    align-items: flex-start;

    @keyframes portal-control-enter {
        from {
            opacity: 0;
            transform: translateY(6px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    ${tablet`
        padding: 1rem;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;             
    `};

    ${mobile`
        padding: 1rem;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    `};

    ${desktop`
        padding: 0.85rem 1rem;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
    `};

    @media (max-width: 760px) {
        > * {
            max-width: 100%;
        }

        input,
        select,
        button {
            max-width: 100%;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
        transition: none;
    }
`;


function UpperControls(props) {
    const { children, ...styledProps } = props;
    return (
        <Header {...styledProps}>
            {children}
        </Header>
    );
}

export default UpperControls;
